import { BaseModel } from '@Core';
import { Camera, CameraPriority } from './Camera';
import { ZonePriority } from './Zones';
import { CameraTaskAttachment } from './CameraTaskAttachment';

export interface CameraTask extends BaseModel {
    CameraId: number;
    Camera?: Camera;

    TaskName: string;

    Problem?: string;

    Solution?: string;

    TaskType?: string;
    SubTask?: string;
    TaskPriority?: TaskPriority;
    TaskStatus: TaskStatus;

    Assignee?: string;

    Note?: string;

    FaultStartDate?: Date;
    AttendingDate?: Date;
    CompleteDate?: Date;
    EndDate: Date;

    CameraTaskAttachments?: CameraTaskAttachment[];

    CameraName?: string;
    CameraPriority?: CameraPriority;
    LocationName?: string;
    ZoneName?: string;
    ZonePriority?: ZonePriority;
}

export enum TaskPriority {
    Low,
    Medium,
    High,
    Critical,
}

export enum TaskStatus {
    Planned,
    Allocated,
    InProgress,
    Completed,
    Cancelled,
}

export enum SpecificTaskTypes {
    AngleDeviation = 'Checking camera angle deviation',
    BatteryHealth = 'Checking camera battery health',
    SDCard = 'Checking camera SD card',
    LowCaptureInvestigation = 'Low capture investigation',
    ExcessiveCaptureInvestigation = 'Excessive capture investigation',
    ReplaceBattery = 'Replacing camera battery',
    ReplaceSDCard = 'Replacing camera SD card',
    ChangeSIMCard = 'Changing camera SIM card',
    ReplaceOrSwapCamera = 'Replacing / swapping camera',
}
